<template>
    <div v-if="show && initialized" class="popup" :class="{inline}">
        <input type="hidden" v-if="!inline" ref="gclid" id="gclid_field" name="gclid_field" value="">
        <div class="bg" @click.prevent="close()"></div>
        <img v-if="!inline" src="/images/purejingles-logo-pink.svg" alt="PUREJingles" class="logo">
        <a v-if="!inline" @click.prevent="close()" class="close close1" href="#">
            <img src="/images/checkout-close.svg" alt="Close popup">
        </a>
        <div class="popup-box">
            <a @click.prevent="close()" class="close close2" href="#">
                <img src="/images/checkout-close.svg" alt="Close popup">
            </a>
            <h3 v-if="useTitle" class="h2">{{ useTitle }}</h3>
            <h2 v-if="useSubtitle" class="h2 black">{{ useSubtitle }}</h2>
            <div class="txt" v-if="useText" v-html="useText"></div>
            <form v-if="!newsletter_submitted" class="form">
                <div class="panel">
                    <div class="fields">
                        <template v-if="is_newsletter_popup">
                            <!-- <input v-model="newsletter_form_data.hp_reason_test" data-hj-allow type="text" name="hp_reason_test" tabindex="-1" automcomplete="off" class="hp"> -->
                            <div class="field w50 s-w50">
                                <input v-model="newsletter_form_data.first_name" data-hj-allow type="text" name="first_name"
                                    :placeholder="window.t('form_first_name')" required>
                                <span v-if="errors.first_name" class="incorrect">{{ errors.first_name }}</span>
                            </div>
                            <div class="field w50 s-w50">
                                <input v-model="newsletter_form_data.last_name" data-hj-allow type="text" name="last_name"
                                    :placeholder="window.t('form_last_name')" required>
                                    <span v-if="errors.last_name" class="incorrect">{{ errors.last_name }}</span>
                            </div>
                            <div class="field w100">
                                <input v-model="newsletter_form_data.email" data-hj-allow type="email" name="email" :placeholder="window.t('form_email')" required>
                                <span v-if="errors.email" class="incorrect">{{ errors.email }}</span>
                            </div>
                        </template>
                        <div class="field w100">
                            <label>{{ window.t('i_am_a') }}</label>
                            <div class="inline-radios">
                                <label>
                                    <input v-model="person" value="director" type="radio"> {{ window.t('director') }}
                                </label>
                                <label>
                                    <input v-model="person" value="imager" type="radio"> {{ window.t('imager') }}
                                </label>
                                <label>
                                    <input v-model="person" value="enduser" type="radio"> {{ window.t('enduser') }}
                                </label>
                            </div>
                        </div>
                        <div v-if="shouldShow('monetize')" class="field w100 animated">
                            <label>{{ window.t('monetize') }}</label>
                            <div class="inline-radios">
                                <label>
                                    <input v-model="monetize" value="public" type="radio"> {{ window.t('public') }}
                                </label>
                                <label>
                                    <input v-model="monetize" value="commercial" type="radio"> {{ window.t('commercial') }}
                                </label>
                                <label>
                                    <input v-model="monetize" value="hobby" type="radio"> {{ window.t('hobby') }}
                                </label>
                            </div>
                        </div>
                        <div v-if="shouldShow('broadcast')" class="field w100 animated">
                            <label>{{ window.t('broadcast_region') }}</label>
                            <div class="inline-radios">
                                <label>
                                    <input v-model="broadcast" value="national" type="radio"> {{ window.t('national') }}
                                </label>
                                <label>
                                    <input v-model="broadcast" value="regional" type="radio"> {{ window.t('regional') }}
                                </label>
                                <label>
                                    <input v-model="broadcast" value="local_online" type="radio"> {{ window.t('local-online') }}
                                </label>
                            </div>
                        </div>
                        <div v-if="shouldShow('looking_for')" class="field w100 animated">
                            <select v-model="looking_for">
                                <option :value="null">{{ window.t('i_am') }}</option>
                                <option value="inspiration">{{ window.t('inspiration') }}</option>
                                <option value="radio_imaging">{{ window.t('radio_imaging') }}</option>
                                <option v-if="shouldShowOption('sonic_branding')" value="sonic_branding">{{ window.t('sonic_branding') }}</option>
                                <option value="contact">{{ window.t('contact') }}</option>
                            </select>
                        </div>
                        <div v-if="shouldShow('format_id')" class="field w100 animated">
                            <select v-model="format_id">
                                <option :value="null">{{ window.t('my_format') }}</option>
                                <option v-for="format in formats" :key="format.id" :value="format.id">{{ format.name }}</option>
                            </select>
                        </div>
                        <template v-if="!is_newsletter_popup && shouldShowContact()">
                            <div class="field w100 animated">
                                <label>{{ window.t('get_contacted') }}</label>
                                <div class="inline-radios">
                                    <label>
                                        <input v-model="contact_me" :value="true" type="radio"> {{ window.t('general_yes') }}
                                    </label>
                                    <label>
                                        <input v-model="contact_me" :value="false" type="radio"> {{ window.t('general_no') }}
                                    </label>
                                </div>
                            </div>
                            <template v-if="contact_me" class="animated">
                                <div class="field w50 s-w50 animated">
                                    <input v-model="assistant_form_data.first_name" data-hj-allow type="text" name="first_name"
                                        :placeholder="window.t('form_first_name')">
                                    <span v-if="errors.first_name" class="incorrect">{{ errors.first_name }}</span>
                                </div>
                                <div class="field w50 s-w50 animated">
                                    <input v-model="assistant_form_data.last_name" data-hj-allow type="text" name="last_name"
                                        :placeholder="window.t('form_last_name')">
                                        <span v-if="errors.last_name" class="incorrect">{{ errors.last_name }}</span>
                                </div>
                                <div class="field w100 animated">
                                    <input v-model="assistant_form_data.email" data-hj-allow type="email" name="email" :placeholder="window.t('form_email')">
                                    <span v-if="errors.email" class="incorrect">{{ errors.email }}</span>
                                </div>
                                <div class="field w100 animated">
                                    <input v-model="assistant_form_data.phone" data-hj-allow type="text" name="phone" :placeholder="window.t('form_phone')">
                                    <span v-if="errors.phone" class="incorrect">{{ errors.phone }}</span>
                                </div>
                            </template>
                        </template>
                        <div v-if="is_newsletter_popup && shouldShow('terms')" class="field w100">
                            <div class="checkbox-wrap">
                                <input v-model="terms" data-hj-allow type="checkbox" name="terms" id="c1" required>
                                <label class="checkbox-label" v-html="window.t('form_terms_agreement', false, {'terms': '<a href=' + (newsletterTermsUrl ? newsletterTermsUrl : '#') + ' target=_blank>' + window.t('form_terms').toLowerCase() +'</a>'})" for="c1"></label>
                                <span v-if="errors.terms" class="incorrect">{{ errors.terms }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <a
                    v-if="!is_newsletter_popup"
                    @click.prevent="executeFirstPossibleAction()"
                    :class="{disabled: !firstPossibleAction || !firstPossibleActionEnabled}"
                    :disabled="!firstPossibleAction || !firstPossibleActionEnabled"
                    href="#"
                    class="btn"
                >{{ button_label ? button_label : 'Help me choose' }}</a>
                <a
                    v-else
                    :data-sitekey="window.siteKey"
                    @click.prevent="signupForNewsletter()"
                    :class="{disabled: shouldDisableNewsletterSubmit}"
                    :disabled="shouldDisableNewsletterSubmit"
                    href="#"
                    class="btn"
                >{{ newsletterSubmitLabel ? newsletterSubmitLabel : 'Sign me up' }}</a>
            </form>
            <div v-else>
                <span v-html="newsletterThanksText"></span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                default: null,
            },
            subtitle: {
                type: String,
                default: null,
            },
            text: {
                type: String,
                default: null,
            },

            forceOpen: {
                type: Boolean,
                default: false,
            },
            newsletterTermsUrl: {
                type: String,
                default: null,
            },
            newsletterSubmitUrl: {
                type: String,
                default: null,
            },
            newsletterSubmitLabel: {
                type: String,
                default: null,
            },
            newsletterThanksText: {
                type: String,
                default: null,
            },
            inline: {
                type: Boolean,
                default: false,
            },
            from: {
                type: String,
                default: null,
            },
            country: {
                type: String,
                default: null,
            },
            language: {
                type: String,
                default: null,
            }
        },
        data() {
            return {
                window,
                useTitle: '',
                useSubtitle: '',
                useText: '',
                button_label: '',

                person: null,
                monetize: null,
                broadcast: null,
                looking_for: null,
                format_id: null,
                terms: null,

                contact_me: null,

                actions: [
                    //Redirect to showcase with format
                    {
                        person: ['director', 'imager'],
                        monetize: ['public', 'commercial'],
                        broadcast: ['national', 'regional'],
                        looking_for: ['inspiration'],
                        format_id: null, //Null means its required, else it should not be in action at all
                        action: this.redirectToShowcase
                    },

                    //Redirect to jinglebox with format
                    {
                        person: ['director', 'imager'],
                        monetize: ['public', 'commercial'],
                        broadcast: ['national', 'regional'],
                        looking_for: ['radio_imaging'],
                        format_id: null,
                        action: this.redirectToJinglebox
                    },

                    //Redirect to visuals page
                    {
                        person: ['director', 'imager'],
                        monetize: ['public', 'commercial'],
                        broadcast: ['national', 'regional'],
                        looking_for: ['sonic_branding'],
                        action: this.redirectToVisuals
                    },

                    //Redirect to contact page
                    {
                        looking_for: ['contact'],
                        action: this.redirectToContact
                    },

                    //Redirect to showcase
                    {
                        person: ['enduser'],
                        monetize: ['public', 'commercial'],
                        broadcast: ['national', 'regional'],
                        looking_for: ['inspiration'],
                        action: this.redirectToShowcase
                    },

                    //Redirect to sounds
                    {
                        person: ['enduser'],
                        monetize: ['public', 'commercial'],
                        broadcast: ['national', 'regional'],
                        looking_for: ['radio_imaging'],
                        format_id: null, //Null means its required, else it should not be in action at all
                        action: this.redirectToSounds
                    },

                    //Redirect to starter kits
                    {
                        person: ['director', 'imager'],
                        monetize: ['commercial', 'public'],
                        broadcast: ['local_online'],
                        looking_for: ['inspiration', 'radio_imaging'],
                        action: this.redirectToStarter
                    },


                    //Redirect to sounds
                    {
                        person: ['imager'],
                        monetize: ['hobby'],
                        skip: [
                            'broadcast',
                            'looking_for',
                        ],
                        // broadcast: ['local_online'],
                        // looking_for: ['inspiration', 'radio_imaging'],
                        enabledIf: {
                            format_id: null
                        },
                        action: this.redirectToSounds
                    },

                    {
                        person: ['director'],
                        monetize: ['hobby'],
                        skip: [
                            'broadcast',
                        ],
                        // broadcast: ['local_online'],
                        // looking_for: ['inspiration', 'radio_imaging'],
                        enabledIf: {
                            looking_for: null,
                            format_id: null
                        },
                        action: this.redirectToStarter
                    },

                    {
                        person: ['enduser'],
                        monetize: ['hobby'],
                        skip: [
                            'broadcast',
                        ],
                        // broadcast: ['local_online'],
                        // looking_for: ['inspiration', 'radio_imaging'],
                        enabledIf: {
                            looking_for: null,
                            format_id: null
                        },
                        action: this.redirectToSounds
                    },

                    {
                        from: 'sounds',
                        format_id: null,
                        action: this.redirectToSounds
                    }
                ],

                questions: [
                    'person',
                    'monetize',
                    'broadcast',
                    'looking_for',
                    'format_id',
                    'terms'
                ],

                jinglebox_url: null,
                showcase_url: null,
                visuals_url: null,
                contact_url: null,
                sounds_url: null,
                formats: [],
                is_newsletter_popup: false,
                show: false,
                initialized: false,

                newsletter_submitted: false,
                newsletter_form_data: {
                    hp_reason_test: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    from: this.from,
                    referrer: this.from,
                    country: this.country,
                    language: this.language,
                    terms: true
                },

                assistant_form_data: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                },

                errors: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    phone: null,
                    terms: null,
                }
            };
        },
        beforeMount() {
            if (!this.inline) {
                window.openWebsiteAssistent = this.open;
            } else {
                window.openInlineWebAssistent = this.open;
            }

            this.useTitle = this.title;
            this.useSubtitle = this.subtitle;
            this.useText = this.text;
        },
        mounted() {

            // TODO: uncommenten als popup getoond moet worden aan bezoeker
            //Opens the assistant if closed cookie is not set AND (this assistant is inline OR this is the only assistant on the page (else window.openInlineWebAssistent would exist))
            // let shouldOpen = !getCookie('website-assistant-closed') && (this.inline || !window.openInlineWebAssistent);

            let shouldOpen = false;
            const hasSelection = !!(window.location.hash && window.location.hash.length > 1);

            if (hasSelection) {
                shouldOpen = false;
            } else {
                if ((window.$_GET && window.$_GET.popup === '1') && (this.inline || !window.openInlineWebAssistent)) {
                    shouldOpen = true;
                }

                if (this.inline && !getCookie('website-assistant-filled')) {
                    shouldOpen = true;
                }

                if (this.forceOpen) {
                    shouldOpen = true;
                }

                if (window.websiteAssistantDisabled) {
                    shouldOpen = false;
                }
            }

            this.init(shouldOpen);
        },
        methods: {
            open(is_newsletter_popup = false) {
                this.newsletter_submitted = false;
                this.is_newsletter_popup = false;
                if (!this.inline) {
                    document.body.classList.add('popup-visible');
                }
                if (is_newsletter_popup) {
                    this.is_newsletter_popup = true;
                }
                this.show = true;

                return false;
            },
            close(force = false) {
                this.show = false;
                document.body.classList.remove('popup-visible');

                this.markClosed();
            },
            shouldShowContact() {
                return ['director', 'imager'].includes(this.person)
                    && ['public', 'commercial'].includes(this.monetize)
                    && ['radio_imaging'].includes(this.looking_for);
            },
            shouldShowOption(option) {
                if (option !== 'sonic_branding') {
                    return true;
                }

                return ['director', 'imager'].includes(this.person)
                &&     ['public', 'commercial'].includes(this.monetize)
                &&     ['national', 'regional'].includes(this.broadcast);
            },
            markClosed() {
                setCookie('website-assistant-closed', '1', 365);
            },
            init(open = false) {
                axios.post('/website-assistant/init', {
                    locale: window.locale
                })
                    .then(response => {
                        if (response.data.hasOwnProperty('formats')) {
                            this.formats = response.data.formats;
                        }
                        if (!this.useTitle && response.data.hasOwnProperty('title')) {
                            this.useTitle = response.data.title;
                        }
                        if (!this.useSubtitle && response.data.hasOwnProperty('subtitle')) {
                            this.useSubtitle = response.data.subtitle;
                        }
                        if (!this.useText && response.data.hasOwnProperty('text')) {
                            this.useText = response.data.text;
                        }
                        if (response.data.hasOwnProperty('button_label')) {
                            this.button_label = response.data.button_label;
                        }
                        if (response.data.hasOwnProperty('jinglebox_url')) {
                            this.jinglebox_url = response.data.jinglebox_url;
                        }
                        if (response.data.hasOwnProperty('showcase_url')) {
                            this.showcase_url = response.data.showcase_url;
                        }
                        if (response.data.hasOwnProperty('visuals_url')) {
                            this.visuals_url = response.data.visuals_url;
                        }
                        if (response.data.hasOwnProperty('contact_url')) {
                            this.contact_url = response.data.contact_url;
                        }
                        if (response.data.hasOwnProperty('sounds_url')) {
                            this.sounds_url = response.data.sounds_url;
                        }
                        if (response.data.hasOwnProperty('starter_url')) {
                            this.starter_url = response.data.starter_url;
                        }

                        this.initialized = true;

                        if (open) {
                            this.open();
                        }
                    })
                    .catch(err => {})
            },
            async signupForNewsletter() {
                let token;

                try {
                    token = await grecaptcha.execute(window.siteKey, {action: 'submit'});
                } catch(error) {
                    return false;
                }

                if (!token) {
                    return false;
                }

                const postData = Object.assign({}, this.newsletter_form_data, {
                    'g-recaptcha-response': token,
                    person: this.person,
                    monetize: this.monetize,
                    broadcast: this.broadcast,
                    format_id: this.format_id,
                    gclid: this.$refs.gclid ? this.$refs.gclid.value : null,
                    referrer: location.toString(),
                });

                try {
                    const response = await axios.post(this.newsletterSubmitUrl, postData);
                    this.sendToGoogleAnalytics();
                    this.newsletter_submitted = true;

                    _gte('click', {
                        'event_category': 'Signup',
                        'event_label': this.newsletterSubmitLabel,
                    });
                } catch (error) {
                    if (error.response.data.errors.hasOwnProperty('first_name')) {
                        this.errors.first_name = error.response.data.errors.first_name[0];
                    }
                    if (error.response.data.errors.hasOwnProperty('last_name')) {
                        this.errors.last_name = error.response.data.errors.last_name[0];
                    }
                    if (error.response.data.errors.hasOwnProperty('email')) {
                        this.errors.email = error.response.data.errors.email[0];
                    }
                    if (error.response.data.errors.hasOwnProperty('terms')) {
                        this.errors.terms = error.response.data.errors.terms[0];
                    }
                }
            },
            async executeFirstPossibleAction() {
                if (!this.firstPossibleActionEnabled) {
                    return false;
                }

                var action = this.firstPossibleAction;

                if (!action || !action.action) {
                    return false;
                }

                this.sendToGoogleAnalytics();

                //Mark as filled
                setCookie('website-assistant-filled', '1', 365);

                await this.sendMaxleadData();

                // slight delay before redirecting to enable google analytics
                if (!this.inline) {
                    setTimeout(()=>{
                        action.action();
                    }, 250);
                } else {
                    this.$root.$emit('toggleFormat', this.format_id);
                    this.close(true);
                }
            },
            sendToGoogleAnalytics() {
                // Send data to Google Analytics. Use the tracker because Tag Manager is used.
                // https://stackoverflow.com/questions/15744042/events-not-being-tracked-in-new-google-analytics-analytics-js-setup/40761709#40761709
                if ('ga' in window) {
                    var tracker = window.ga.getAll()[0];
                    if (tracker) {
                        tracker.send('event', 'Keuzemenu', 'person', this.person);
                        tracker.send('event', 'Keuzemenu', 'monetize', this.monetize);
                        tracker.send('event', 'Keuzemenu', 'broadcast', this.broadcast);
                        tracker.send('event', 'Keuzemenu', 'looking_for', this.looking_for);
                        tracker.send('event', 'Keuzemenu', 'format', this.formatName);
                        tracker.send('event', 'Keuzemenu', 'profile', this.googleAnalyticsString);
                    }
                }
            },
            async sendMaxleadData() {
                try {
                    await axios.post('/post-maxlead-data', {
                        referrer: location.toString(),
                        person: this.person,
                        monetize: this.monetize,
                        looking_for: this.looking_for,
                        broadcast: this.broadcast,
                        format_id: this.format_id,
                        contact_me: this.contact_me,
                        first_name: this.assistant_form_data.first_name,
                        last_name: this.assistant_form_data.last_name,
                        email: this.assistant_form_data.email,
                        phone: this.assistant_form_data.phone,
                    });
                } catch(exc) {}
            },
            redirectToShowcase() {
                if (this.inline) {
                    this.close(true);
                    return true;
                }

                if (!this.showcase_url) {
                    this.close(true);
                    return false;
                }

                this.markClosed();

                if (location.hostname != 'pure.audio') {
                    window.location.href = this.showcase_url;
                }
            },
            redirectToJinglebox() {
                if (!this.jinglebox_url) {
                    this.close(true);
                    return false;
                }

                var str = 'search=||-||formats=' + this.format_id + '||-||tempos=||-||genres=||-||selection=||-||sort=||-||sortDirection=asc';
                var jingleboxCode = btoa(str);

                this.markClosed();

                if (location.hostname != 'pure.audio') {
                    window.location.href = this.jinglebox_url + '/' + jingleboxCode;
                }
            },
            redirectToVisuals() {
                if (this.inline) {
                    this.close(true);
                    return true;
                }

                if (!this.visuals_url) {
                    this.close(true);
                    return false;
                }

                this.markClosed();

                if (location.hostname != 'pure.audio') {
                    window.location.href = this.visuals_url;
                }
            },
            redirectToContact() {
                if (this.inline) {
                    this.close(true);
                    return true;
                }

                if (!this.contact_url) {
                    this.close(true);
                    return false;
                }

                this.markClosed();

                if (location.hostname != 'pure.audio') {
                    window.location.href = this.contact_url;
                }
            },
            redirectToSounds() {
                if (!this.sounds_url) {
                    this.close(true);
                    return false;
                }

                var str = 'search=||-||genres=||-||keys=||-||moods=||-||types=||-||sort=||-||sortDirection=asc';
                var soundsCode = btoa(str);

                this.markClosed();

                if (location.hostname != 'pure.audio') {
                    window.location.href = this.sounds_url + '/' + soundsCode;
                }
            },
            redirectToStarter() {
                if (this.inline) {
                    this.close(true);
                    return true;
                }

                if (!this.starter_url) {
                    this.close(true);
                    return false;
                }

                this.markClosed();

                if (location.hostname != 'pure.audio') {
                    window.location.href = this.starter_url;
                }
            },
            // shouldSkip(question) {
            //     return this.skipQuestions.includes(question);
            // },
            shouldShow(question) {
                return this.questionsToShow.includes(question);
            }
        },
        computed: {
            shouldDisableNewsletterSubmit() {
                return !this.firstPossibleAction
                    || !this.firstPossibleActionEnabled
                    || !this.terms
                    || !this.newsletter_form_data.first_name
                    || !this.newsletter_form_data.last_name
                    || !this.newsletter_form_data.email
            },
            firstPossibleAction() {
                //Loop all actions
                for(var i in this.actions) {
                    var action = this.actions[i];
                    var foundAction  = true;

                    //Loop properties to check
                    for(var j in this.questions) {
                        var checkProperty = this.questions[j];

                        //If action has not the property, we dont have to check
                        if (!action.hasOwnProperty(checkProperty)) {
                            continue;
                        }

                        //Action has property, check current properties with actions properties.

                        //If current property is not in actions check property
                        if (_.isArray(action[checkProperty]) && action[checkProperty].indexOf(this[checkProperty]) == -1) {
                            foundAction = false;
                            break;
                        }

                        //Null means the checkProperty is required
                        if (action[checkProperty] === null && !this[checkProperty]) {
                            foundAction = false;
                            break;
                        }
                    }

                    if (foundAction) {
                        return action;
                    }
                }

                return null;
            },
            firstPossibleActionEnabled() {
                if (!this.firstPossibleAction) {
                    return false;
                }

                if (!this.firstPossibleAction.hasOwnProperty('enabledIf')) {
                    return true;
                }

                var enabledIf = this.firstPossibleAction.enabledIf;

                var enabled = true;

                for(var prop in enabledIf) {
                    var val = enabledIf[prop];

                    if (_.isArray(val) && !val.includes(this[prop])) {
                        enabled = false;
                        break;
                    }

                    if (val === null && !this[prop]) {
                        enabled = false;
                        break;
                    }
                }

                return enabled;
            },
            questionsToShow() {
                var questions = this.questions
                    .filter(question => !this.skipQuestions.includes(question));

                var show = [];
                var showedLast = false;

                for(var i in questions) {
                    var question = questions[i];

                    if (this[question]) {
                        show.push(question);
                        continue;
                    }

                    if (!showedLast) {
                        show.push(question);
                        showedLast = true;
                        continue;
                    }

                    break;
                }

                return show;
            },
            skipQuestions() {
                if (!this.firstPossibleAction) {
                    return [];
                }

                if (!this.firstPossibleAction.skip) {
                    return [];
                }


                return this.firstPossibleAction.skip.concat([]);
            },
            formatLookup() {
                var lookup = {};

                for(var i in this.formats) {
                    var format = this.formats[i];

                    lookup[format.id] = format;
                }

                return lookup;
            },
            formatName() {
                var format = this.formatLookup[this.format_id] || null;
                var formatName = '';
                if (format) {
                    formatName = format.name;
                }
                return formatName;
            },
            googleAnalyticsString() {
                return (this.person || '') + '|' + (this.monetize || '') + '|' + (this.broadcast || '') + '|' + (this.looking_for || '') + '|' + this.formatName;
            }
        }
    }
</script>
